// extracted by mini-css-extract-plugin
export default {"tabsItem":"custom-tabs-item_tabsItem__Sj72V","tabsItemSelected":"custom-tabs-item_tabsItemSelected__RgmZV"};